import { ReactElement } from "react";
import {
  IContentAreaProps,
  IDataContext, IIndicator,
  IMenuButton,
  ISelectedNode,
  IViewController,
  SchemaNodeType
} from "../../types";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { IDashboard } from "./types";

import DashboardPage from "./dashboardPage";


class Module implements IViewController {

  private dashboardButton: IMenuButton = {
    title: "Indicators",
    icon: <DashboardIcon/>,
    color: "cyan",
    dataContext: {
      title: "Indicators",
      module: "dashboardRT",
      subModule: "dashboardRT"
    }
  };

  private buttons = [this.dashboardButton];

  getModuleName(): string{
    return "dashboardRT";
  }

  getView(dataContext: IDataContext, props: IContentAreaProps): ReactElement {

    if (dataContext.flag === "RT-DASHBOARD") {
      return <DashboardPage key={`dashboard-page-${dataContext.data.dashboardID}`} parentSize={props.parentSize} defaultDashboard={dataContext.data as IDashboard} />;
    }

    return <DashboardPage parentSize={props.parentSize} />;
  }

  getButtons(node: ISelectedNode): IMenuButton[] {
    return node.type === SchemaNodeType.Zone ? [this.dashboardButton] : [];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "") {
      return <div />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
